import styled from 'styled-components'

export const MasonaryGrid = styled.div`
    position: relative;
    cursor: pointer;
    height: 100%;
    &:before {
        border: ${props => (props.isGifClicked ? '3px solid #f3c520' : 'none')};
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 2px;
        left: 0;
        background-color: rgba(0, 0, 0, 0.2);
    }
`

export const TickIcon = styled.div`
    position: absolute;
    background: rgb(243, 197, 32);
    top: 0px;
    right: 0px;
`
export const TickIconInactive = styled(TickIcon)`
    background: transparent;
`
export const TickIconImage = styled.img`
    height: 50px;
    width: 50px;
    @media (max-width: 992px) {
        height: 30px;
        width: 30px;
    }
    @media (max-width: 768px) {
        height: 30px;
        width: 30px;
    }
`

export const Div = styled.div`
    position: absolute;
    top: 0;
`

export const Image = styled.img`
    width: 100%;
`

export const MasonaryGridBody = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 30px 30px;
    color: #fff;
    display: flex;
    flex-direction: column;
`

export const GridTitle = styled.div`
    font-size: 28px;
    font-weight: bold;
    margin: 0px 0px 10px 0px;
`

export const GridAuthor = styled.div`
    font-size: 14px;
    font-weight: 300;
`
